export default __webpack_public_path__ + "static/media/mobilite.444851a5.svg";